import type { DashboardPeriod } from '~/app/services/organization-manager-dashboard/organization-manager-dashboard.types';
import type { GetChargingKpisResponseDto } from './charging-kpi.types';

/** Stand-in payload until the charging KPI API is on main. */
export const CHARGING_KPIS_MOCK: GetChargingKpisResponseDto = {
  sessionSuccess: {
    ratePercent: 94,
    successfulCount: 1880,
    terminalCount: 2000,
    inProgressCount: 12,
    targetPercent: 95,
  },
  weightedUptime: {
    ratePercent: 96.4,
    chargersIncluded: 286,
    chargersExcludedZeroUsage: 8,
    chargersWithoutStatus: 6,
    totalWeightKwh: 48250.5,
    source: 'ocpp-status',
  },
  dropOffCauses: [
    { id: 'payment-terminal', count: 42, percent: 48 },
    { id: 'connector-locking', count: 28, percent: 32 },
    { id: 'session-timeout', count: 12, percent: 14 },
    { id: 'other', count: 6, percent: 6 },
  ],
};

/** Same window deltas as the executive dashboard mock, so the period control still moves. */
function sessionRateForPeriod(period: DashboardPeriod): number {
  switch (period) {
    case 'q1-2026':
      return 91;
    case 'q2-2026':
      return 93;
    case 'q3-2026':
      return 94;
    case 'q4-2026':
      return 95;
    case 'last-12-months':
      return 93;
  }
}

export function chargingKpisForPeriod(
  period: DashboardPeriod,
): GetChargingKpisResponseDto {
  const kpis = structuredClone(CHARGING_KPIS_MOCK);
  kpis.sessionSuccess.ratePercent = sessionRateForPeriod(period);
  return kpis;
}
